import { EKanbanCardProperty, IGetState, TBoardId, TKanbanCardProperty } from 'app/types/types';
import { Dispatch, ThunkAction } from 'app/types/actions';
import {
    boardSetDefaultCardPreviewHiddenProperties
} from '../../../../../../../../../rest/effects/board/boardSetDefaultCardPreviewHiddenProperties';
import {
    getBoardDefaultCardPreviewHiddenProperties
} from '../../../../../../../../../store/model/board/selectors/getBoardDefaultCardPreviewHiddenProperties';
import { getPreviewKey } from '../helpers/getPreviewKey';
import { EAsidePanelProperty } from '../../../../../../asidePanel/components/AsidePanel/types';
import {
    boardUserMetaSetCardPreviewHiddenProperties
} from '../../../../../../../../../rest/effects/board/boardUserMetaSetCardPreviewHiddenProperties';
import { getToggledProperties } from '../../../../../../preview/Preview/hocs/PreviewHOC/selectors/getToggledProperties';
import {
    SegmentCardEvent,
    SegmentCardOptions,
    SegmentCardOptionStatusValue,
    SegmentCardPreviewSettingsSourceValue
} from '../../../../../../../../../middlewares/segment/trackEntities/cardEvents';
import { segmentTrackAction } from '../../../../../../../../../middlewares/segment';
import {
    boardUserMetaSetCardPreviewCustomProperties
} from '../../../../../../../../../rest/effects/board/boardUserMetaSetCardPreviewCustomProperties';
import {
    boardSetDefaultCardPreviewCustomProperties
} from '../../../../../../../../../rest/effects/board/boardSetDefaultCardPreviewCustomProperties';
import {
    getBoardDefaultCardPreviewCustomProperties
} from '../../../../../../../../../store/model/board/selectors/getBoardDefaultCardPreviewCustomProperties';

export const onPreviewToggle = (
    boardId: TBoardId,
    cardProperty: TKanbanCardProperty | EAsidePanelProperty,
    option?: string,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        const key = option ? EKanbanCardProperty.CUSTOM_PROPERTIES + option : getPreviewKey(cardProperty);
        const properties = getBoardDefaultCardPreviewHiddenProperties(getState(), boardId);
        let isOn = false;
        let newProperties = properties;
        const customProperties = getBoardDefaultCardPreviewCustomProperties(getState(), boardId);
        let newCustomProperties = [...customProperties];
        if (option) {
            if (newCustomProperties.includes(key)) {
                newCustomProperties = customProperties.filter(item => item !== key);
            } else {
                newCustomProperties.push(key);
            }
        } else {
            newProperties = getToggledProperties(properties, key);
        }
        if (
            newProperties.length > properties.length ||
            newCustomProperties.length > customProperties.length
        ) {
            isOn = true;
        }
        dispatch(segmentTrackAction(SegmentCardEvent.CARD_PREVIEW_SETTING_SELECTED, {
            name: SegmentCardOptions.SOURCE,
            value: SegmentCardPreviewSettingsSourceValue.BOARD_SETTINGS
        }, [
            {
                name: SegmentCardOptions.TYPE,
                value: key.toLowerCase().replace('_', ''),
            },
            {
                name: SegmentCardOptions.STATUS,
                value: isOn ? SegmentCardOptionStatusValue.ON : SegmentCardOptionStatusValue.OFF,
            }
        ]));
        if (option) {
            dispatch(boardSetDefaultCardPreviewCustomProperties(boardId, newCustomProperties));
            dispatch(boardUserMetaSetCardPreviewCustomProperties(boardId, newCustomProperties));
        } else {
            dispatch(boardSetDefaultCardPreviewHiddenProperties(boardId, newProperties));
            dispatch(boardUserMetaSetCardPreviewHiddenProperties(boardId, newProperties));
        }
    };
    return action;
};
